'use client';
import { useAuth } from '@core/features-core/auth/client';
import { HighlightsText } from './highlights-text';
import { SponsoredFundHeader } from './sponsored-fund-header';
import { SponsoredB3Header } from './sponsored-b3-header';
import { SponsoredAssetDescription } from './sponsored-asset-description';
import { RetornoAdsAssetCard } from './retorno-ads-asset-card';
import { withHiddenSponsored } from './components/with-hidden-sponsored';
import { withSpacingContainer } from './components/with-container';
import { cn } from '@core/design-system/tailwind/lib/utils';

export const withHiddenPrime =
  (Component: any) =>
  ({ minHeight, ...props }: any) => {
    const { initialized, userIsPremium } = useAuth();

    if (initialized && userIsPremium) return null;

    return (
      <div
        className={cn(
          'w-full min-h-[220px] sm:min-h-[200px]',
          props?.className
        )}
      >
        <Component {...props} />
      </div>
    );
  };

export const RetornoAds = {
  Content: withHiddenPrime(RetornoAdsAssetCard),
  SpacingRetornoAds: withHiddenSponsored(
    withHiddenPrime(withSpacingContainer(RetornoAdsAssetCard))
  ),
  HighlightsText: HighlightsText,
  SponsoredFundHeader,
  SponsoredB3Header,
  SponsoredAssetDescription,
};

export const SpacingRetornoAds = withHiddenSponsored(
  withHiddenPrime(withSpacingContainer(RetornoAdsAssetCard))
);

export * from './sponsored-sheets';
